import Constants from '../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}depuber/`;

const title = "Holy Road - The Teenager";
const description = "Emuna is fourteen years old. She had a dance performance, together with her friend Hallel but just before the performance, Hallel was stabbed to death. In her very own bedroom.";
const featuredImage = `${imageFolder}depuber/omslag.jpg`;

export default [
    {
        type: "Meta",
        title: title,
        meta: [
            {"property": "og:title", "content": title},
            {"property": "og:url", "content": `${Constants.DOMAIN}${Constants.STORY_URL}depuber`},
            {"property": "description", "content": ""},
            {"property": "og:description", "content": description},
            {"property": "og:image", "content": featuredImage},
            {"property": "twitter:card", "content": `summary_large_image`},
            {"property": "twitter:title", "content": title},
            {"property": "twitter:description", "content": description},
            {"property": "twitter:image", "content": featuredImage},
        ]
    },
    {
        type: "Quote",
        quote: description,
    },
    {
        type: "Paragraph",
        text: "Hallel Yaffe Ariel had pink pillows on her bunk bed, just like every other thirteen-year-old girl. The released photo by the Israeli army shows a bed besmeared with blood. Her Palestinian murderer evidently must have stabbed her excessively before she died, as the pool of blood on the floor suggests. Three friends of Hallel tell us about their lives. What do their bedrooms look like? How has Hallel’s death influenced their lives? And how does it feel to grow up in a contentious settlement?"
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}00__mobile.jpg`,
            tablet: `${imageFolder}00__tablet.jpg`,
            desktop: `${imageFolder}00.jpg`,
            alt: "",
            text: "The Ariel family has placed photos of Hallel and the rest of her family throughout the house"
        }
    },
    {
        type: "Paragraph",
        text: "Emuna danced with Hallel. Heichal was a good friend of Hallel, not a ‘best friend forever’, but still a friend. Noam had been in Hallel’s class for only two years, but still speaks a lot about her. Hallel Yaffe Ariel was thirteen years old. She lived with her parents and two little sisters in a house near the border of Kiryat Arba, a Jewish settlement situated in the West Bank, which is occupied by Israel. Her father owns a vineyard at home."
    },
    {
        type: "Paragraph",
        text: "The house is located quite remotely, which is probably part of the reason why Mohammed Nasser Tra’ayra, a seventeen-year-old Palestinian boy, chose Hallel’s house on 30 June 2016 to realize his plan to murder a Jewish colonist. Tra’ayra was from Bani Na’im, a small town only six kilometers to the east of the settlement. The teenage girl was home alone. She did not stand a chance."
    },
    {
        type: "Iframe",
        url: "https://player.vimeo.com/video/209452055",
        text: "Reuters’ news video reporting the death of Hallel."
    },
    {
        type: "Quote",
        quote: "We had just danced together at a performance, the night before her death. Four days after her death, we danced again – to commemorate her.",
        person: "Emuna Yeshurun (14), friend of Hallel."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}01.jpg`,
            tablet: `${imageFolder}01.jpg`,
            desktop: `${imageFolder}01.jpg`,
            alt: "",
            text: "Emuna on her bed in her room."
        }
    },
    {
        type: "Paragraph",
        text: "Emuna, Heichal and Noam are fourteen years old now. Although the murder undoubtedly was a shock, the death of their friend is definitely not the only trauma they have experienced in their young lives. Still, the three girls behave like usual teenagers. Emuna wears a beanie, practices hip hop dance and is a fan of the boy band Big Time Rush. She likes to go shopping with friends in the Malha-shopping center in Jerusalem. Noam, who lives amidst Palestinians in a small but heavily-guarded neighborhood, prefers to race downhill in a wheelbarrow tied to a bicycle. In doing so, however, she needs to beware of ‘Arabians and stray dogs’. Heichel, on the other hand, likes to write lyrics. About her feelings. "
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow1/02__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/02.jpg`,
                desktop: `${imageFolder}slideshow1/02.jpg`,
                alt: "",
                text: "Emuna Yeshurun (14): ‘I practice hip hop, ballet and modern dance. I knew Hallel very well. We were in class together. Just the evening before her death we had a dance performance together. Four days after her death, we danced again – to commemorate her.’",
            },
            {
                mobile: `${imageFolder}slideshow1/03__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/03.jpg`,
                desktop: `${imageFolder}slideshow1/03.jpg`,
                alt: "",
                text: "‘I am a fan of Big Time Rush. That is a boyband. It is quite old, they do not even exist anymore.’"
            },
            {
                mobile: `${imageFolder}slideshow1/04__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/04.jpg`,
                desktop: `${imageFolder}slideshow1/04.jpg`,
                alt: "",
                text: "‘I want to become a fighter pilot.’"
            },
            {
                mobile: `${imageFolder}slideshow1/05__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/05.jpg`,
                desktop: `${imageFolder}slideshow1/05.jpg`,
                alt: "",
                text: "‘My message to the world is: there are two peoples here, but we are the ones being killed. It is not normal to attend the funeral of another teenager.’"
            },
            {
                mobile: `${imageFolder}slideshow1/06__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/06.jpg`,
                desktop: `${imageFolder}slideshow1/06.jpg`,
                alt: "",
                text: "‘My most valuable possession? My mobile phone. And a note from Hallel’"
            },
            {
                mobile: `${imageFolder}slideshow1/07__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/07.jpg`,
                desktop: `${imageFolder}slideshow1/07.jpg`,
                alt: "",
                text: "‘At school we study the Jewish life. Sometimes I wonder what they learn at school. Probably how to hate Jews’"
            },
            {
                mobile: `${imageFolder}slideshow1/08__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/08.jpg`,
                desktop: `${imageFolder}slideshow1/08.jpg`,
                alt: "",
                text: "‘Hallel did not have a life yet, she was not married, did not have children yet. I think about that when I am lying in bed. Then I imagine how the stabbing must have taken place’"
            },
            {
                mobile: `${imageFolder}slideshow1/09__mobile.jpg`,
                tablet: `${imageFolder}slideshow1/09.jpg`,
                desktop: `${imageFolder}slideshow1/09.jpg`,
                alt: "",
                text: "‘I would not be able to stab someone, even if somebody gave me a knife and the body of an Arab. How could he do that to Hallel?’"
            }
        ]
    },
    {
        type: "Paragraph",
        text: " Emuna, Heichal and Noam are Orthodox Jews, just like most of the colonists of Kiryat Arba. These girls grow up in big families and at home, there are respectively around seven, six and nine children. Kiryat Arba is situated very close to Hebron, the place where The Cave of the Patriarchs is located. This is, in fact, considered one of the holiest places in Judaism. Emuna (her name translates as ‘religion’ in Hebrew) goes to The Cave on foot every Saturday to pray."
    },
    {
        type: "Quote",
        quote: "My songs are basically about everything, and about how I feel. I did not write about Hallel specifically, but, actually, one of the songs is quite sad.",
        person: "Heichal Kornstam (14), friend of Hallel"
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}10__mobile.jpg`,
            tablet: `${imageFolder}10.jpg`,
            desktop: `${imageFolder}10.jpg`,
            alt: "",
            text: "Heichal on her bed in her room"
        }
    },
    {
        type: "Paragraph",
        text: "The common thread in their lives is the ‘Arab’ situation. Kiryat Arba, situated far into the West Bank, is just like all other Jewish settlements considered ‘illegal’ by the international law. These settlements are surrounded by the Palestinians – and are often targeted by the Palestinians. "
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow2/11__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/11.jpg`,
                desktop: `${imageFolder}slideshow2/11.jpg`,
                alt: "",
                text: "Heichal Kornstam (14): ‘Hallel was a very friendly girl, she liked to laugh a lot. She was also very thoughtful and caring. We used to talk a lot with each other at school. We sat next to each other in English class. She was very good at English’",
            },
            {
                mobile: `${imageFolder}slideshow2/12__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/12.jpg`,
                desktop: `${imageFolder}slideshow2/12.jpg`,
                alt: "",
                text: "‘Sometimes we go to Jerusalem. To go bowling or to meet friends. I do not read that much anymore, I prefer making music. I write songs and I sing. I like Twenty One Pilots and Bastille.’"
            },
            {
                mobile: `${imageFolder}slideshow2/13__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/13.jpg`,
                desktop: `${imageFolder}slideshow2/13.jpg`,
                alt: "",
                text: "'My songs are basically about everything, and about how I feel. I did not write about Hallel specifically, but, actually, one of the songs is quite sad.’"
            },
            {
                mobile: `${imageFolder}slideshow2/14__mobile.jpg`,
                tablet: `${imageFolder}slideshow2/14.jpg`,
                desktop: `${imageFolder}slideshow2/14.jpg`,
                alt: "",
                text: "'It depends on the Arabs what is going to happen. They are the ones committing attacks. The government allows them to live here and they commit attacks. It is very disappointing that Israel does not send them away.’"
            }
        ]
    },
    {
        type: "Paragraph",
        text: "There are various reasons for Jews to choose a colonist life. Some decide to become a colonist merely because the settlements offer a spacious and cheap living. In Kiryat Arba, however, the situation is different. Ideology plays a very important role. In Kiryat Arba, they believe that ‘this land is ours, it belongs to us’. The international community is critical about this situation, but the citizens of Kiryat Arba are not interested in hearing these opinions. They follow the Torah, where it is clearly stated that ‘Judea’, as they tend to call the southern parts of the West Bank, is the biblical heartland of the Jewish people."
    },
    {
        type: "Paragraph",
        text: "This ideology, however, has its fanatic sides. For instance, the colonist Baruch Goldstein from Kiryat Arba committed a massacre in the Ibrahimi Mosque, which is also called ‘the Cave of the Patriarchs’, in 1994. In this act, twenty-nine Muslims were killed and 125 were injured. Goldstein’s own grave is located in the Kahane-Park in Kiryat Arba, which was named after the leader of the extreme-right, terroristic organization Kach. The grave has become a small pilgrimage destination for religious nationalists."
    },
    {
        type: "Quote",
        quote: "We are obliged to go to school by bus. The windows of the bus are bullet proof, and there are always armed guards that go with us.",
        person: "Noam Sarah Richie (14), friend of Hallel"
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}15__mobile.jpg`,
            tablet: `${imageFolder}15.jpg`,
            desktop: `${imageFolder}15.jpg`,
            alt: "",
            text: "Noam on her bed in her room."
        }
    },
    {
        type: "Paragraph",
        text: "The parents of the girls are well aware of what they are doing. Kiryat Arba, in fact, was actually a step back to a calmer environment for the family of Heichal, as they used to live in a Jewish settlement in the Gaza Strip. According to her mother Rina, Hallel was very religious as well. Likewise, the Ariel family is very concerned with the current movement that intends to erect a Third Jewish Temple on the Temple Mountain Haram al-Sharif in the eastern part of Jerusalem, a location at which there are now two mosques."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow3/16__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/16.jpg`,
                desktop: `${imageFolder}slideshow3/16.jpg`,
                alt: "",
                text: "Noam Sarah Richi (14): ‘It is dangerous to walk to the village down the hill. It is even too dangerous to walk to school. There is a fence surrounding the village, but in this particular neighborhood we live very close to the Arabs.’"
            },
            {
                mobile: `${imageFolder}slideshow3/17__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/17.jpg`,
                desktop: `${imageFolder}slideshow3/17.jpg`,
                alt: "",
                text: "‘We are obliged to go to school by bus. The windows of the bus are bullet proof, and there are always armed guards that go with us.’"
            },
            {
                mobile: `${imageFolder}slideshow3/18__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/18.jpg`,
                desktop: `${imageFolder}slideshow3/18.jpg`,
                alt: "",
                text: "Does Noam have any contact with Arabs? She laughs: 'No. At most we insult each other.’"
            },
            {
                mobile: `${imageFolder}slideshow3/19__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/19.jpg`,
                desktop: `${imageFolder}slideshow3/19.jpg`,
                alt: "",
                text: "‘Sometimes I think about Arab girls of my own age. But I do not want any contact. They do not really interest me, not even what type of music they listen to. I can hear their music anyways when they have another loud wedding’"
            },
            {
                mobile: `${imageFolder}slideshow3/20__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/20.jpg`,
                desktop: `${imageFolder}slideshow3/20.jpg`,
                alt: "",
                text: "‘My eighteen-year-old sister practices taekwondo, mixed martial arts, boxing, and krav maga. She has also taught me a little bit. And there is a self-defense training for women, but that would not help if you are stabbed. It is mostly for your self-confidence.’"
            },
            {
                mobile: `${imageFolder}slideshow3/21__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/21.jpg`,
                desktop: `${imageFolder}slideshow3/21.jpg`,
                alt: "",
                text: "‘If somebody tried to stab me, I would through my phone at him, I think.’"
            },
            {
                mobile: `${imageFolder}slideshow3/22__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/22.jpg`,
                desktop: `${imageFolder}slideshow3/22.jpg`,
                alt: "",
                text: "‘A friend of mine once started screaming really loudly because she imagined the stabbing.’"
            },
            {
                mobile: `${imageFolder}slideshow3/23__mobile.jpg`,
                tablet: `${imageFolder}slideshow3/23.jpg`,
                desktop: `${imageFolder}slideshow3/23.jpg`,
                alt: "",
                text: "‘Sometimes I am having a great time with my friends, but then I suddenly think: what if this friend dies too?’"
            }
        ]
    },
    {
        type: "Paragraph",
        text: "Most of Hallel’s friends would like to stay in Kiryat Arba in the future. The introvert Heichal, however, thinks that it is ‘a great disappointment’ that the Israeli government is not undertaking any further actions concerning the deporting of Palestinians. Also, dancer Emuna believes that it is her duty to stay in Kiryat Arba: ‘we must grow – otherwise, Kiryat Arba will become Arab. All surrounding villages are Arab. If we grow, we will swallow them up. This, I believe, is our best solution to prevent new terrorist attacks.’"
    },
]


// WEBPACK FOOTER //
// ./src/data/stories/story1.js